module.exports = __webpack_public_path__ + "img/android-download-logo.4b27880d.png";